import { tv } from 'tailwind-variants'

export const rewardTagVariants = tv({
  base: [
    'flex items-center justify-between',
    'h-[34px]',
    'gap-1',
    'text-base font-bold',
    'rounded-10 bg-glass-overlay-strong'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'shadow-yellow-top-accent-inset',
      green: 'shadow-green-top-accent-inset',
      blue: 'shadow-blue-top-accent-inset',
      pink: 'shadow-pink-top-accent-inset'
    }
  }
})

export const rewardTagButtonVariants = tv({
  base: [
    'flex justify-center items-center',
    'h-full',
    'px-2',
    'text-base font-bold [text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]',
    'rounded-r-10 shadow-white-top-accent-inset'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'bg-yellow',
      green: 'bg-dark-green',
      blue: 'bg-blue',
      pink: 'bg-pink-flamingo'
    }
  }
})
